interface CertificateProps {
	className?: string;
}

const Certificate = ({ className }: CertificateProps) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			d="M10.8333 14.5846V18.3346L12.5 17.0846L14.1667 18.3346V14.5846M8.33333 15.8346H4.16667C3.72464 15.8346 3.30072 15.659 2.98816 15.3465C2.67559 15.0339 2.5 14.61 2.5 14.168V5.83464C2.5 4.91797 3.25 4.16797 4.16667 4.16797H15.8333C16.2754 4.16797 16.6993 4.34356 17.0118 4.65612C17.3244 4.96868 17.5 5.39261 17.5 5.83464V14.168C17.4997 14.4602 17.4225 14.7473 17.2763 15.0003C17.13 15.2534 16.9198 15.4635 16.6667 15.6096M5 7.5013H15M5 10.0013H7.5M5 12.5013H6.66667M15 12.5013C15 13.882 13.8807 15.0013 12.5 15.0013C11.1193 15.0013 10 13.882 10 12.5013C10 11.1206 11.1193 10.0013 12.5 10.0013C13.8807 10.0013 15 11.1206 15 12.5013Z"
			stroke="#5B5B5B"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default Certificate;
